import React, { useState } from 'react';
import './rejectionpopup.css';
import { ClientService } from '../../../../../services/clientService';
import { Spinner } from 'react-bootstrap';
const RejectionPopup = ({ isRejectionPopupVisible, confirmRejection, closePopup, candidateId, clientId }) => {
  const [loading, setLoading] = useState(false);

  const handleConfirmRejection = async () => {
    setLoading(true);
    try {
      await ClientService.updateCandidateStatus(candidateId, clientId, 'REJECTED');
      confirmRejection();
    } catch (error) {
      alert('Failed to reject candidate. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (!isRejectionPopupVisible) return null;

  return (
    <div className="rejection-popup-overlay">
      <div className="rejection-popup-container">
        <h2>You Are Going to Reject The Candidate</h2>
        <p>Are you sure you want to proceed?</p>
        <div className="rejection-actions">
          <button className="rejection-cancel" onClick={closePopup} disabled={loading}>
            Cancel
          </button>
          <button
            className={`rejection-yes ${loading ? 'loading' : ''}`}
            onClick={handleConfirmRejection}
            disabled={loading}
          >
            {loading ? (
              <>
                <Spinner
                  animation="border"
                  role="status"
                  size="sm"
                  style={{ color: '#F35824', marginRight: '8px' }}
                >
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </>
            ) : (
              'Yes'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RejectionPopup;
